import { FC, useEffect, useState } from "react";
import KeyNumberHistory from "./KeyNumberHistory";
import AddProductPopup from "./AddProductPopup";
import BatchEditPopup from "./BatchEditPopup";
import GanttChart from "./GanttChart";
import ProductPopup from "./ProductDetailsPopup";
import QrScannerFind from "./QrScannerFind";
import { InventoryData } from "../../../../types/inventoryData";
import { useInventory } from "../../InventoryProvider";

type InventoryPageDialogTypes = {
  popupToggles: {
    history: boolean;
    addProduct: boolean;
    batchEdit: boolean;
    ganttChart: boolean;
    batchQrScannerToggle: boolean;
    batchEditMode: boolean;
  };
  setPopupToggles: React.Dispatch<
    React.SetStateAction<{
      history: boolean;
      addProduct: boolean;
      batchEdit: boolean;
      ganttChart: boolean;
      batchQrScannerToggle: boolean;
      batchEditMode: boolean;
    }>
  >;
};

const InventoryPageDialogs: FC<InventoryPageDialogTypes> = ({
  popupToggles,
  setPopupToggles,
}) => {
  const [baseListOfScannedQr, setBaseListOfScannedQr] = useState<number[]>([]);

  const {
    rows,
    selectedProduct,
    setSelectedProduct,
    selectedProductIds,
    setFilteredRows,
  } = useInventory();

  const handleSelectScannedRows = (
    listOfScannedQr: string[],
    QrValueJustScanned: string
  ) => {
    const newSelectedRow = rows
      .filter((row): row is InventoryData => row !== undefined)
      .find((r) => r.serial == QrValueJustScanned);

    if (!newSelectedRow) return;

    setFilteredRows((prev) => {
      const newFilteredRows = prev.map((oldrow) => {
        if (oldrow.productId == newSelectedRow.productId) {
          return {
            ...oldrow,
            isSelected: true,
          };
        } else return oldrow;
      });
      return newFilteredRows;
    });
  };

  return (
    <>
      {popupToggles.batchQrScannerToggle && (
        <QrScannerFind
          onScannedListChange={handleSelectScannedRows}
          qrScannerToggle={popupToggles.batchQrScannerToggle}
          setQrScannerToggleFalse={() =>
            setPopupToggles({ ...popupToggles, batchQrScannerToggle: false })
          }
        />
      )}
      {popupToggles.ganttChart && (
        <GanttChart
          open={popupToggles.ganttChart}
          handleClose={() =>
            setPopupToggles({ ...popupToggles, ganttChart: false })
          }
        />
      )}
      <KeyNumberHistory
        open={popupToggles.history}
        handleClose={() => setPopupToggles({ ...popupToggles, history: false })}
      />
      {selectedProduct && (
        <ProductPopup
          handleClose={() => {
            setSelectedProduct(undefined);
          }}
          open={selectedProduct ? true : false}
        />
      )}
      {popupToggles.addProduct && (
        <AddProductPopup
          open={popupToggles.addProduct}
          handleClose={() =>
            setPopupToggles({ ...popupToggles, addProduct: false })
          }
          handleOpenBatchEdit={() =>
            setPopupToggles({ ...popupToggles, batchEdit: true })
          }
        />
      )}
      {popupToggles.batchEdit && (
        <BatchEditPopup
          open={popupToggles.batchEdit}
          handleClose={() =>
            setPopupToggles({ ...popupToggles, batchEdit: false })
          }
        />
      )}{" "}
    </>
  );
};

export default InventoryPageDialogs;
